import React from 'react';

function UserDepartment(props) {
  let humanizedDepartment = <div></div>;
  if (props.department == null || props.department == "no_department")
  {
    humanizedDepartment = <div>NONE</div>
  }
  else
  {
  humanizedDepartment = <div>{props.department.split("_")[0].toUpperCase()}</div>
  }
  return humanizedDepartment;
}

export default UserDepartment;
